
import { Badge } from "@/components/ui/badge";
import { Crown } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { useState, useEffect } from "react";
import { calculateAge } from "@/utils/ageCalculator";

interface EntryMetadataProps {
  age: string;
  isPremium: boolean;
  babyBirthday?: string;
}

const EntryMetadata = ({ age, isPremium, babyBirthday }: EntryMetadataProps) => {
  const { language } = useLanguage();
  const [displayAge, setDisplayAge] = useState<string>("");
  
  useEffect(() => {
    // If we have a birthday, calculate the age in the current language
    if (babyBirthday) {
      try {
        const calculatedAge = calculateAge(new Date(babyBirthday), language);
        setDisplayAge(calculatedAge);
        console.log(`Calculated age: ${calculatedAge} in language: ${language} from birthday: ${babyBirthday}`);
      } catch (error) {
        console.error("Error calculating age:", error);
        setDisplayAge(age || "");
      }
    } else {
      setDisplayAge(age || "");
    }
  }, [babyBirthday, language, age]);
  
  return (
    <div className="flex items-center gap-2">
      {displayAge && (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent">
          {displayAge}
        </span>
      )}
      
      {isPremium && (
        <Badge variant="default" className="bg-amber-500 hover:bg-amber-600 flex items-center gap-1">
          <Crown className="h-3 w-3" />
          <span>{t('premium.premiumFeature', language)}</span>
        </Badge>
      )}
    </div>
  );
};

export default EntryMetadata;
